import { render, staticRenderFns } from "./CompanyObjectEditor.vue?vue&type=template&id=4a1d509f&scoped=true"
import script from "./CompanyObjectEditor.vue?vue&type=script&lang=js"
export * from "./CompanyObjectEditor.vue?vue&type=script&lang=js"
import style0 from "./CompanyObjectEditor.vue?vue&type=style&index=0&id=4a1d509f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1d509f",
  null
  
)

export default component.exports